import AddToAppleWallet from '../../../../banking/components/cards/AddToAppleWallet';

const AppleWalletScreen = () => {
    return <AddToAppleWallet />;
};

export default AppleWalletScreen;
